export default "__VITE_ASSET__i$nlD$_H__"